import { render } from "./halfDate.vue?vue&type=template&id=063afb9a&ts=true"
import script from "./halfDate.vue?vue&type=script&lang=tsx"
export * from "./halfDate.vue?vue&type=script&lang=tsx"

import "./halfDate.vue?vue&type=style&index=0&id=063afb9a&lang=less"

import exportComponent from "E:\\qihe\\ly-visitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__